//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const attr = function(attributes, key) {
    if (!attributes) {
      return null;
    }

    return attributes[key] ? attributes[key].nodeValue : null;
  };

  const generateToggleDefinitions = function(toggles) {
    return _(toggles).map((toggle) => {
      const attributes = toggle.attributes;

      return {
        name: attr(attributes, 'name'),
        key: attr(attributes, 'key'),
        sortKey: attr(attributes, 'sortKey') || attr(attributes, 'key'),
      };
    });
  };

  angular.module('curalate').directive('datatableGrid', () => ({
    restrict: 'E',
    scope: {},
    require: '^datatable',
    compile(element) {
      const toggles = element.find('datatable-grid-toggles datatable-grid-toggle');
      const toggleObjects = generateToggleDefinitions(toggles);

      const template = element.find('datatable-grid-cell');
      const wrapper = angular.element('<div class="angular-datatable grid datatables-next no-padding col-xs-12"></div>');
      const header = angular.element('<div class="grid-header"></div>');
      const gridContainer = angular.element('<div class="grid-container"></div>');
      const gridItem = angular.element('<div class="grid-item pull-left"></div>').attr('ng-repeat', 'context in model.items');

      const toggleContainer = angular.element('<div class="col-xs-9 no-padding toggles-container"></div>');
      const toggle = angular.element('<toggle toggle-select="model.sort(value)" watched-option="model.sorting.currentSortKey"></toggle>');

      const directionContainer = angular.element('<div class="col-xs-3 pull-right text-right no-padding"></div>');
      const directionButton = angular.element('<button class="btn btn-prim-inverse sortable"></button>');

      gridItem.append(template.html());
      gridContainer.append(gridItem);

                // Toggles
      _(toggleObjects).each((definition) => {
        const toggleOption = angular.element('<toggle-option />');

        toggleOption.attr('name', definition.name);
        toggleOption.attr('value', definition.sortKey);

        toggle.append(toggleOption);
      });

      toggleContainer.append(toggle);

                // Direction Button
      directionButton.attr('ng-class', '{"sort-asc": model.sorting.direction === "asc", "sort-desc": model.sorting.direction === "desc" }');
      directionButton.attr('ng-bind', `model.sorting.direction === "asc"  
        ? (model.sorting.currentSortKey === "name" ? "A-Z" : "Ascending") 
        : (model.sorting.currentSortKey === "name" ? "Z-A" : "Descending")`);
      directionButton.attr('ng-click', 'model.changeSortDirection()');

      directionContainer.append(directionButton);

      header.append(toggleContainer);
      header.append(directionContainer);
      header.append('<div class="clearfix"></div>');
      wrapper.append(header);
      wrapper.append(gridContainer);

      return {
        pre: null,
        post(scope, elem, attrs, datatable) {
          if (datatable.hasCustomHeader()) {
            wrapper.find('.grid-header').remove();
          }

          datatable.registerView('grid', wrapper);
        },
      };
    },
  }));
})();
